const CONTROL_ACCOUNT_MARKET_KEYS = new Set([
  "UNITEDKINGDOM",
  "INTERNATIONALEUROCARD",
  "SWEDEN",
  "NORWAY",
]);

export const shouldUseControlAccountLabel = (marketKey) =>
  CONTROL_ACCOUNT_MARKET_KEYS.has(marketKey);
